export default {"src":"/_next/static/media/solar.add1885e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};